export const INITIAL_VALUES = {
  name: '',
  type: '',
  nif: '',
  city: '',
  activitySpheres: [],
  manager: null,
  description: '',
};
